import React from "react";

export default function Blog() {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Blog</h1>
      <p>Coming soon: insights on mindset, growth, parenting, and personal breakthroughs.</p>
    </div>
  );
}